import React from 'react'

const NoMatch = () => {
  return (
    <div>このページは存在しません</div>
  )
}

export default NoMatch